var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ApiDocument" }, [
    _c("div", { staticClass: "top", on: { click: _vm.initDoc } }, [
      _c("img", { attrs: { id: "logo", src: require("../assets/logo.png") } }),
      _vm._v(" "),
      _c("h2", [_vm._v("API Test")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _vm.showBack
        ? _c("div", { staticClass: "backBtn", on: { click: _vm.goBack } }, [
            _c("i", { staticClass: "el-icon-place" }),
            _vm._v(" "),
            _c("span", [_vm._v("GAMES")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "agnetBox" },
        [
          _c(
            "el-input",
            {
              staticClass: "agentType",
              attrs: {
                placeholder: "Please Input MerchantCode",
                maxlength: "36"
              },
              model: {
                value: _vm.merchantCode,
                callback: function($$v) {
                  _vm.merchantCode = $$v
                },
                expression: "merchantCode"
              }
            },
            [_c("template", { slot: "prepend" }, [_vm._v("merchantCode")])],
            2
          ),
          _vm._v(" "),
          _c(
            "el-input",
            {
              staticClass: "agentType",
              attrs: { placeholder: "Please Input Agent", maxlength: "20" },
              on: { change: _vm.changeKey },
              model: {
                value: _vm.agentKey,
                callback: function($$v) {
                  _vm.agentKey = $$v
                },
                expression: "agentKey"
              }
            },
            [_c("template", { slot: "prepend" }, [_vm._v("agent")])],
            2
          ),
          _vm._v(" "),
          _c(
            "el-input",
            {
              staticClass: "agentType",
              attrs: { placeholder: "Please Input Domain", maxlength: "20" },
              on: { change: _vm.changeDomain },
              model: {
                value: _vm.domainName,
                callback: function($$v) {
                  _vm.domainName = $$v
                },
                expression: "domainName"
              }
            },
            [_c("template", { slot: "prepend" }, [_vm._v("domain")])],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "docBox" }, [
        _c("div", { staticClass: "group" }, [
          _c("h2", { staticClass: "groupTitle" }, [_vm._v("PLAYER")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("createPlayer")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "36" },
                  model: {
                    value: _vm.createPlayerForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.createPlayerForm, "playerID", $$v)
                    },
                    expression: "createPlayerForm.playerID"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("playerID")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.createPlayer },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.createPlayer,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "createPlayer", $$v)
                  },
                  expression: "responselist.createPlayer"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("kickPlayer")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  attrs: {
                    placeholder: "Please Input playerID",
                    maxlength: "36"
                  },
                  model: {
                    value: _vm.kickPlayerForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.kickPlayerForm, "playerID", $$v)
                    },
                    expression: "kickPlayerForm.playerID"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "holderType",
                      attrs: { slot: "prepend", placeholder: "Select" },
                      slot: "prepend",
                      model: {
                        value: _vm.kickPlayerForm.actionType,
                        callback: function($$v) {
                          _vm.$set(_vm.kickPlayerForm, "actionType", $$v)
                        },
                        expression: "kickPlayerForm.actionType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Single Player(0)", value: "0" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "All Player Of Agent(1)", value: "1" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.kickPlayer },
                    slot: "append"
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.kickPlayer,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "kickPlayer", $$v)
                  },
                  expression: "responselist.kickPlayer"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("lockPlayer")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "36" },
                  model: {
                    value: _vm.lockPlayerForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.lockPlayerForm, "playerID", $$v)
                    },
                    expression: "lockPlayerForm.playerID"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("playerID")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.lockPlayer },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.lockPlayer,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "lockPlayer", $$v)
                  },
                  expression: "responselist.lockPlayer"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("unLockPlayer")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "36" },
                  model: {
                    value: _vm.unLockPlayerForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.unLockPlayerForm, "playerID", $$v)
                    },
                    expression: "unLockPlayerForm.playerID"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("playerID")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.unLockPlayer },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.unLockPlayer,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "unLockPlayer", $$v)
                  },
                  expression: "responselist.unLockPlayer"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("playerStatus")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "36" },
                  model: {
                    value: _vm.playerStatusForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.playerStatusForm, "playerID", $$v)
                    },
                    expression: "playerStatusForm.playerID"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("playerID")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.playerStatus },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.playerStatus,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "playerStatus", $$v)
                  },
                  expression: "responselist.playerStatus"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "group" }, [
          _c("h2", { staticClass: "groupTitle" }, [_vm._v("PLAY GAME")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("playGame")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "36" },
                  model: {
                    value: _vm.playGameForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.playGameForm, "playerID", $$v)
                    },
                    expression: "playGameForm.playerID"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("playerID")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { placeholder: "(Optional)", maxlength: "60" },
                  model: {
                    value: _vm.playGameForm.returnUrl,
                    callback: function($$v) {
                      _vm.$set(_vm.playGameForm, "returnUrl", $$v)
                    },
                    expression: "playGameForm.returnUrl"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("returnUrl")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: {
                    placeholder: "true/false(Optional)",
                    maxlength: "60"
                  },
                  model: {
                    value: _vm.playGameForm.hasCurrency,
                    callback: function($$v) {
                      _vm.$set(_vm.playGameForm, "hasCurrency", $$v)
                    },
                    expression: "playGameForm.hasCurrency"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("hasCurrency")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: {
                    placeholder: "true/false(Optional)",
                    maxlength: "20"
                  },
                  model: {
                    value: _vm.playGameForm.hasLogo,
                    callback: function($$v) {
                      _vm.$set(_vm.playGameForm, "hasLogo", $$v)
                    },
                    expression: "playGameForm.hasLogo"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("hasLogo")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  attrs: {
                    placeholder: "Please Input gameCode",
                    maxlength: "20"
                  },
                  model: {
                    value: _vm.playGameForm.gameCode,
                    callback: function($$v) {
                      _vm.$set(_vm.playGameForm, "gameCode", $$v)
                    },
                    expression: "playGameForm.gameCode"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "holderType",
                      attrs: {
                        slot: "prepend",
                        placeholder: "lang",
                        maxlength: "20"
                      },
                      slot: "prepend",
                      model: {
                        value: _vm.playGameForm.lang,
                        callback: function($$v) {
                          _vm.$set(_vm.playGameForm, "lang", $$v)
                        },
                        expression: "playGameForm.lang"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "zh-CN", value: "zh-CN" }
                      }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "th", value: "th" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "en", value: "en" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.playGame2 },
                    slot: "append"
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "holderType",
                  attrs: {
                    slot: "prepend",
                    placeholder: "錢包類型",
                    maxlength: "20"
                  },
                  slot: "prepend",
                  model: {
                    value: _vm.playGameForm.walletType,
                    callback: function($$v) {
                      _vm.$set(_vm.playGameForm, "walletType", $$v)
                    },
                    expression: "playGameForm.walletType"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "一般錢包", value: 0 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "免轉錢包", value: 2 } })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.playGame,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "playGame", $$v)
                  },
                  expression: "responselist.playGame"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("playLobby")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "20" },
                  model: {
                    value: _vm.tmpId,
                    callback: function($$v) {
                      _vm.tmpId = $$v
                    },
                    expression: "tmpId"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("playerID")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.playLobby2 },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.playLobby,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "playLobby", $$v)
                  },
                  expression: "responselist.playLobby"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [
                _vm._v("trialPlayGame")
              ]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "20" },
                  model: {
                    value: _vm.trialPlayGameForm.gameCode,
                    callback: function($$v) {
                      _vm.$set(_vm.trialPlayGameForm, "gameCode", $$v)
                    },
                    expression: "trialPlayGameForm.gameCode"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("gameCode")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.trialPlayGame },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.trialPlayGame,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "trialPlayGame", $$v)
                  },
                  expression: "responselist.trialPlayGame"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "group" }, [
          _c("h2", { staticClass: "groupTitle" }, [_vm._v("POINTS")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("deposit")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "36" },
                  model: {
                    value: _vm.depositForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.depositForm, "playerID", $$v)
                    },
                    expression: "depositForm.playerID"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("playerID")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "40" },
                  model: {
                    value: _vm.depositForm.transferID,
                    callback: function($$v) {
                      _vm.$set(_vm.depositForm, "transferID", $$v)
                    },
                    expression: "depositForm.transferID"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("transferID")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "9" },
                  model: {
                    value: _vm.depositForm.pointAmount,
                    callback: function($$v) {
                      _vm.$set(_vm.depositForm, "pointAmount", $$v)
                    },
                    expression: "depositForm.pointAmount"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("pointAmount")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.deposit },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.deposit,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "deposit", $$v)
                  },
                  expression: "responselist.deposit"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("withdrawal")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "36" },
                  model: {
                    value: _vm.withdrawalForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.withdrawalForm, "playerID", $$v)
                    },
                    expression: "withdrawalForm.playerID"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("playerID")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "40" },
                  model: {
                    value: _vm.withdrawalForm.transferID,
                    callback: function($$v) {
                      _vm.$set(_vm.withdrawalForm, "transferID", $$v)
                    },
                    expression: "withdrawalForm.transferID"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("transferID")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  attrs: {
                    placeholder: "Please Input pointAmount",
                    maxlength: "9"
                  },
                  model: {
                    value: _vm.withdrawalForm.pointAmount,
                    callback: function($$v) {
                      _vm.$set(_vm.withdrawalForm, "pointAmount", $$v)
                    },
                    expression: "withdrawalForm.pointAmount"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "holderType",
                      attrs: { slot: "prepend", placeholder: "Select" },
                      slot: "prepend",
                      model: {
                        value: _vm.withdrawalForm.pickType,
                        callback: function($$v) {
                          _vm.$set(_vm.withdrawalForm, "pickType", $$v)
                        },
                        expression: "withdrawalForm.pickType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Withdrawal All(F)", value: "F" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "Withdrawal Custom(C)", value: "C" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.withdrawal },
                    slot: "append"
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.withdrawal,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "withdrawal", $$v)
                  },
                  expression: "responselist.withdrawal"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [
                _vm._v("checkTransfer")
              ]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "40" },
                  model: {
                    value: _vm.checkTransferForm.transferID,
                    callback: function($$v) {
                      _vm.$set(_vm.checkTransferForm, "transferID", $$v)
                    },
                    expression: "checkTransferForm.transferID"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("transferID")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.checkTransfer },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.checkTransfer,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "checkTransfer", $$v)
                  },
                  expression: "responselist.checkTransfer"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("queryPoint")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "36" },
                  model: {
                    value: _vm.queryPointForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.queryPointForm, "playerID", $$v)
                    },
                    expression: "queryPointForm.playerID"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("playerID")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.queryPoint },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.queryPoint,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "queryPoint", $$v)
                  },
                  expression: "responselist.queryPoint"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "group" }, [
          _c("h2", { staticClass: "groupTitle" }, [_vm._v("RECORD")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [
                _vm._v("gamerecordbyTime")
              ]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: {
                    maxlength: "20",
                    placeholder: "YYYY-MM-DD HH:mm ex:(2021-01-01 00:00)"
                  },
                  model: {
                    value: _vm.gameRecordByTimeForm.beginDateTime,
                    callback: function($$v) {
                      _vm.$set(_vm.gameRecordByTimeForm, "beginDateTime", $$v)
                    },
                    expression: "gameRecordByTimeForm.beginDateTime"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("beginDateTime")])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: {
                    maxlength: "20",
                    placeholder: "YYYY-MM-DD HH:mm ex:(2021-01-01 00:00)"
                  },
                  model: {
                    value: _vm.gameRecordByTimeForm.endDateTime,
                    callback: function($$v) {
                      _vm.$set(_vm.gameRecordByTimeForm, "endDateTime", $$v)
                    },
                    expression: "gameRecordByTimeForm.endDateTime"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("endDateTime")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "20" },
                  model: {
                    value: _vm.gameRecordByTimeForm.gameType,
                    callback: function($$v) {
                      _vm.$set(_vm.gameRecordByTimeForm, "gameType", $$v)
                    },
                    expression: "gameRecordByTimeForm.gameType"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("gameType")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.gameRecordByTime },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.gamerecordbyTime,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "gamerecordbyTime", $$v)
                  },
                  expression: "responselist.gamerecordbyTime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [
                _vm._v("tradeRecordByTime")
              ]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: {
                    maxlength: "20",
                    placeholder: "YYYY-MM-DD HH:mm:ss ex:(2021-01-01 00:00:00)"
                  },
                  model: {
                    value: _vm.tradeRecordByTimeForm.beginDateTime,
                    callback: function($$v) {
                      _vm.$set(_vm.tradeRecordByTimeForm, "beginDateTime", $$v)
                    },
                    expression: "tradeRecordByTimeForm.beginDateTime"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("beginDateTime")])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: {
                    maxlength: "20",
                    placeholder: "YYYY-MM-DD HH:mm:ss ex:(2021-01-01 00:00:00)"
                  },
                  model: {
                    value: _vm.tradeRecordByTimeForm.endDateTime,
                    callback: function($$v) {
                      _vm.$set(_vm.tradeRecordByTimeForm, "endDateTime", $$v)
                    },
                    expression: "tradeRecordByTimeForm.endDateTime"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("endDateTime")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "36" },
                  model: {
                    value: _vm.tradeRecordByTimeForm.playerID,
                    callback: function($$v) {
                      _vm.$set(_vm.tradeRecordByTimeForm, "playerID", $$v)
                    },
                    expression: "tradeRecordByTimeForm.playerID"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("playerID")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.tradeRecordByTime },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.tradeRecordByTime,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "tradeRecordByTime", $$v)
                  },
                  expression: "responselist.tradeRecordByTime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [
                _vm._v("onlineplayers")
              ]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "60" },
                  model: {
                    value: _vm.onlineplayers.pageIndex,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.onlineplayers,
                        "pageIndex",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "onlineplayers.pageIndex"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("pageIndex")])],
                2
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "60" },
                  model: {
                    value: _vm.onlineplayers.pageSize,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.onlineplayers,
                        "pageSize",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "onlineplayers.pageSize"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("pageSize")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.getonlineplayers },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.onlineplayers,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "onlineplayers", $$v)
                  },
                  expression: "responselist.onlineplayers"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [
                _vm._v("playerGameDetail")
              ]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "60" },
                  model: {
                    value: _vm.playerGameDetail.gameTurn,
                    callback: function($$v) {
                      _vm.$set(_vm.playerGameDetail, "gameTurn", $$v)
                    },
                    expression: "playerGameDetail.gameTurn"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("gameTurn")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.getGameDetail },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.playerGameDetail,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "playerGameDetail", $$v)
                  },
                  expression: "responselist.playerGameDetail"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [
                _vm._v("playerdailyreport")
              ]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: {
                    maxlength: "60",
                    placeholder: "YYYY-MM-DD ex:(2021-01-01)"
                  },
                  model: {
                    value: _vm.playerDailyReport.gameDate,
                    callback: function($$v) {
                      _vm.$set(_vm.playerDailyReport, "gameDate", $$v)
                    },
                    expression: "playerDailyReport.gameDate"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("gameDate")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.getPlayerDailyReport },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.playerdailyreport,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "playerdailyreport", $$v)
                  },
                  expression: "responselist.playerdailyreport"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("playerspoint")]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "60" },
                  model: {
                    value: _vm.playerID,
                    callback: function($$v) {
                      _vm.playerID = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "playerID"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("playerID")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.getplayerspoint },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.playerspoint,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "playerspoint", $$v)
                  },
                  expression: "responselist.playerspoint"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [
                _vm._v("jackpotstatus")
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "send",
                      attrs: { type: "primary", icon: "el-icon-document" },
                      on: { click: _vm.getJackpotStatus }
                    },
                    [_vm._v("jackpotstatus")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.jackpotstatus,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "jackpotstatus", $$v)
                  },
                  expression: "responselist.jackpotstatus"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [_vm._v("gameList")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "send",
                      attrs: { type: "primary", icon: "el-icon-document" },
                      on: { click: _vm.gameList }
                    },
                    [_vm._v("gameList")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.gameList,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "gameList", $$v)
                  },
                  expression: "responselist.gameList"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apiBox" },
            [
              _c("span", { staticClass: "apiTitle" }, [
                _vm._v("gameList(POST)")
              ]),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { maxlength: "60" },
                  model: {
                    value: _vm.gamelistPost.lang,
                    callback: function($$v) {
                      _vm.$set(_vm.gamelistPost, "lang", $$v)
                    },
                    expression: "gamelistPost.lang"
                  }
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("lang")]),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "send",
                    attrs: { slot: "append", icon: "el-icon-position" },
                    on: { click: _vm.gameListPost },
                    slot: "append"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "responseBox",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "API Response",
                  readonly: ""
                },
                model: {
                  value: _vm.responselist.gameListPost,
                  callback: function($$v) {
                    _vm.$set(_vm.responselist, "gameListPost", $$v)
                  },
                  expression: "responselist.gameListPost"
                }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-552480d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-552480d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiDocument.vue
// module id = null
// module chunks = 